export default __webpack_public_path__ + "static/media/light-mode-beans.67feacfe.png";